const StyleType = {
  PRIMARY: 'is-primary',
  SECONDARY: 'is-secondary',
};

export default StyleType;
